import { inject, Injectable } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { AttachOrderFilesModalComponent, AttachOrderFilesModalData } from 'app/app-modules/modal';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class AttachOrderFilesModalService {
  private readonly _dialogService = inject(DialogService);

  open({ data }: { data: AttachOrderFilesModalData }) {
    return firstValueFrom(
      this._dialogService.open(AttachOrderFilesModalComponent, {
        header: undefined,
        modal: true,
        showHeader: false,
        closable: true,
        closeOnEscape: false,
        data,
      }).onClose
    );
  }
}
